export const asignacionMasivaPuestoNormalize = (x) => ({
    idAsignacionMasivaPuesto: x.idAsignacionMasivaPuesto ?? x.IdAsignacionMasivaPuesto,
    idCurso: x.idCurso ?? x.IdCurso,
    idPuesto: x.idPuesto ?? x.IdPuesto,
    fechaLimite: x.fechaLimite ?? x.FechaLimite,
    activo: x.activo ?? x.Activo ?? true,
});
